var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { buttonClasses } from '@mui/material/Button';
// components
import { Icon } from '@iconify/react';
// ----------------------------------------------------------------------
var dateList = [
    'DatePicker',
    'DateTimePicker',
    'StaticDatePicker',
    'DesktopDatePicker',
    'DesktopDateTimePicker',
    //
    'MobileDatePicker',
    'MobileDateTimePicker'
];
var timeList = ['TimePicker', 'MobileTimePicker', 'StaticTimePicker', 'DesktopTimePicker'];
var switchIcon = function () { return _jsx(Icon, { icon: 'eva:chevron-down-fill', width: 24 }); };
var leftIcon = function () { return _jsx(Icon, { icon: 'eva:arrow-ios-back-fill', width: 24 }); };
var rightIcon = function () { return _jsx(Icon, { icon: 'eva:arrow-ios-forward-fill', width: 24 }); };
var calendarIcon = function () { return _jsx(Icon, { icon: 'solar:calendar-mark-bold-duotone', width: 24 }); };
var clockIcon = function () { return _jsx(Icon, { icon: 'solar:clock-circle-outline', width: 24 }); };
var desktopTypes = dateList.reduce(function (result, currentValue) {
    result["Mui".concat(currentValue)] = {
        defaultProps: {
            slots: {
                openPickerIcon: calendarIcon,
                leftArrowIcon: leftIcon,
                rightArrowIcon: rightIcon,
                switchViewIcon: switchIcon
            }
        }
    };
    return result;
}, {});
var timeTypes = timeList.reduce(function (result, currentValue) {
    result["Mui".concat(currentValue)] = {
        defaultProps: {
            slots: {
                openPickerIcon: clockIcon,
                rightArrowIcon: rightIcon,
                switchViewIcon: switchIcon
            }
        }
    };
    return result;
}, {});
export function datePicker(theme) {
    var _a;
    return __assign(__assign({ MuiPickersLayout: {
            styleOverrides: {
                root: {
                    '& .MuiPickersLayout-actionBar': (_a = {},
                        _a["& .".concat(buttonClasses.root, ":last-of-type")] = {
                            backgroundColor: theme.palette.text.primary,
                            color: theme.palette.mode === 'light'
                                ? theme.palette.common.white
                                : theme.palette.grey[800]
                        },
                        _a)
                }
            }
        } }, desktopTypes), timeTypes);
}
